import { maxSize } from 'constants/screenSize';
import {
  ScreenType,
  ScreenStyleConfig,
} from 'hooks/styleMediaQuery/useMediaQuery';

export const screenLayoutConfigurations: Record<
  ScreenType,
  ScreenStyleConfig
> = {
  mobile: {
    card: {
      style: { width: maxSize, overflowY: 'auto' },
    },
  },
  tablet: {
    card: {
      style: { width: maxSize, overflowY: 'auto' },
    },
  },
  largeScreen: {
    card: {
      style: { width: maxSize, overflowY: 'auto' },
    },
  },
};
